@if (customer) {
  <app-content-header [historyBack]="false" (backEvent)="onBack()" [headline]="customer.name"></app-content-header>
  <div class="h3 mb-3">{{ 'customer_details_headline' | i18next }}</div>
  <app-customer-navigation [id]="customerId"></app-customer-navigation>
  <div class="card card-nb m-3">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <app-customer-form
            [customer]="customer"
            [countries]="countries"
            submitButtonLabel="app_save"
            [showElectronicInvoiceMail]="showElectronicInvoiceMailInputField"
            (formSubmit)="onSubmit($event)"
          ></app-customer-form>
        </div>
      </div>
    </div>
  </div>
}
